import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngular,
  faBootstrap,
  faCss3,
  faGithub,
  faHtml5,
  faJs,
  faNodeJs,
  faReact,
} from "@fortawesome/free-brands-svg-icons";

import "./styles/skill.css";
import { faDatabase } from "@fortawesome/free-solid-svg-icons";

const Skills = () => {
  return (
    <div className="skill-container">
      <div className="skill">
        <FontAwesomeIcon icon={faJs} title="JavaScript" />
      </div>
      <div className="skill">
        <FontAwesomeIcon icon={faReact} title="ReactJs" />
      </div>
      <div className="skill">
        <FontAwesomeIcon icon={faHtml5} title="HTML" />
      </div>
      <div className="skill">
        <FontAwesomeIcon icon={faCss3} title="CSS" />
      </div>
      <div className="skill">
        <FontAwesomeIcon icon={faBootstrap} title="Bootstrap" />
      </div>
      <div className="skill">
        <FontAwesomeIcon icon={faAngular} title="Angular" />
      </div>
      <div className="skill">
        <FontAwesomeIcon icon={faNodeJs} title="NodeJs" />
      </div>
      <div className="skill">
        <FontAwesomeIcon icon={faDatabase} title="SQL" />
      </div>
      <div className="skill">
        <FontAwesomeIcon icon={faGithub} title="Git/GitHub" />
      </div>
    </div>
  );
};

export default Skills;
